import React from 'react';
import { ButtonClean, ToolbarButton } from '@fourthwall/components';
import { DownloadIcon } from '@fourthwall/icons';
export const DownloadButton = ({ type, onDownload }) => {
    const [isDownloading, setIsDownloading] = React.useState(false);
    const handleDownload = async () => {
        setIsDownloading(true);
        await onDownload();
        setIsDownloading(false);
    };
    if (type === 'icon') {
        return (React.createElement(ToolbarButton, { isLoading: isDownloading, disabled: isDownloading, label: "Download", icon: DownloadIcon, onClick: handleDownload }));
    }
    return (React.createElement(ButtonClean, { label: isDownloading ? 'Downloading...' : 'Download', icon: DownloadIcon, appearance: "secondary", disabled: isDownloading, onClick: handleDownload }));
};
